<template>
  <!-- 修改信息对话框 -->
  <el-dialog :visible.sync="dialogVisible" :before-close="closeEditDialog" :close-on-click-modal="false">
    <div slot="title" class="el-dialog__title"><div class="title-left"></div><slot name="title">{{$t('personCenterV2.editTeam')}}</slot><div class="title-right"></div></div>
    <!-- 表单区域 -->
    <el-form :model="ruleForm" :hide-required-asterisk="true" :rules="editTeamInfoRules" ref="ruleForm" class="demo-ruleForm">
      <el-form-item :label="$t('personCenterV2.teamName')" prop="name">
        <el-input v-model.trim="ruleForm.name" autocomplete="off" :maxlength="16"> </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="btn_cancle">{{ $t('personCenterV2.cancle') }}</el-button>
      <el-button type="primary" v-preventReClick="2000" @click="sureDialog()">{{ $t('personCenterV2.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resetTeamName } from '@/services/userInfo'
export default {
  name: 'editTeam',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    MyTeamInfo: Array,
  },
  data() {
    //   团队名校验
    var checkTeamName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('personCenterV2.teamNameNotEmpty')))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        id: null,
        name: '',
      },
      editTeamInfoRules: {
        name: [{ validator: checkTeamName, trigger: 'blur' }],
      },
    }
  },
  methods: {
    // 关闭重置表单
    closeEditDialog() {
      this.$refs.ruleForm.resetFields()
      this.$emit('closeTeam')
    },
    handleClose() {
      this.$refs.ruleForm.clearValidate()
      this.$emit('closeTeam')
    },
    // 修改团队名字
    sureDialog() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const result = await resetTeamName(this.ruleForm)
          this.$message.success(this.$i18n.locale === 'zh' ? '修改成功' : this.$t('personCenterV2.logOutSuccess'))
          this.$parent.editUserInfo() // 调用父组件方法，更新头部团队名
          this.$emit('closeTeam')
        }
      })
    },
  },

  watch: {
    MyTeamInfo: function (e) {
      e.forEach((item) => {
        this.ruleForm.name = item.teamName
        this.ruleForm.id = item.companyId
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import './assets/style.less';
</style>
